<template>
  <div class="logger-sys-bd tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.myApiName" :placeholder="$t('base_u8.qsrssgjz')" style="width: 100%" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="onClear">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('base_u8.jie_kou_ming_cheng')">
          <custom-select placeholder="" url="logsU8UrlTypeList" v-model="url" :props="{ label: 'name', value: 'url' }" @change="onUrlChange"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_u8.guan_jian_can_shu')">
          <el-select v-model="urlValue" placeholder="" clearable="">
            <el-option v-for="item in urlItem.bizIdMap" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 后端说这个字段不需要筛选 -->
        <!-- <el-form-item label="是否执行">
          <custom-select v-model="formSearch.isRuned" code="isynergy_cloud_bool_true"></custom-select>
        </el-form-item> -->
        <el-form-item :label="$t('Common.com_status')">
          <custom-select v-model="formSearch.isSuccess" code="success_state" placeholder=""></custom-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        index
        tableCode="u8_logger"
        v-loading="isLoading"
        :data="systemLogList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['isSuccess', 'action']"
      >
        <template v-slot:isSuccess="scope">
          <span v-if="scope.row.response.code == 1" style="color: #25b864">{{ $t('Common.com_success') }}</span>
          <span v-else style="color: red">{{ $t('Common.com_fail') }}</span>
        </template>
        <template v-slot:action="scope">
          <el-button type="text" size="mini" @click="onDetail(scope.row)">{{ $t('Common.com_details') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <content-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></content-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import contentDialog from './children/u8_content_dialog';

export default {
  name: 'loggerU8',
  mixins: [resetFormSearchMixins],
  components: { contentDialog },
  data() {
    return {
      sysList: [],
      isLoading: false,
      // 分页
      formSearch: {
        pageSize: 50,
        pageNum: 1,

        myApiName: '',
        isRuned: '',
        isSuccess: '',
      },
      // 日志列表
      systemLogList: [],
      totalRows: null,
      // 新增修改弹窗
      dialogVisible: false,
      dialogModel: {},
      link: null,

      url: '',
      urlValue: '',

      urlItem: {
        bizIdMap: [],
      },
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

  },
  methods: {
    onClear() {
      this.url = '';
      this.urlValue = '';
      this.urlItem = {
        bizIdMap: [],
      };
      this.clearFilter();
    },
    onDetail(row) {
      this.dialogModel = {
        data: row,
        title: row.myApiName,
      };
      this.dialogVisible = true;
    },
    onUrlChange(e) {
      this.urlValue = '';
      if (e) {
        this.urlItem = e;
      } else {
        this.urlItem = {
          bizIdMap: [],
        };
      }
    },
    getReqData() {
      const ret = {
        ...this.formSearch,
      };

      if (ret.isSuccess) {
        ret.isSuccess = ret.isSuccess === 'true';
      }

      if (this.url) {
        ret.url = this.url;
        if (this.urlValue) {
          ret.bizKeyVauleList = this.urlItem.bizIdMap;
        }
      }

      return ret;
    },
    // 获取列表
    getTableList: function () {
      const reqData = this.getReqData();
      this.$postJSON(apis.logsU8RecordsPage, reqData).then((res) => {
        const recordsData = res.data.list;

        this.systemLogList = recordsData;
        this.totalRows = res.data.total;
      });
    },
    // clearFilter: function () {
    //   this.formSearch.bizId = '';
    //   this.formSearch.uri = '';
    //   this.formSearch.hostIp = '';
    //   this.dataTimes = null; // 生效时间
    //   this.getTableList();
    // },
    // 重写表格列筛选
    // filterChange: function (value) {
    //   this.formSearch = Object.assign(this.formSearch, value);
    //   this.formSearch.appName = this.formSearch.appName.length ? this.formSearch.appName : undefined;
    //   this.formSearch.success = this.formSearch.success.length ? this.formSearch.success : undefined;
    //   this.formSearch.logLevel = this.formSearch.logLevel.length ? this.formSearch.logLevel : undefined;

    //   this.onPageChange({ page: 1 });
    // },
    // 查看推送配置
    seePaclageItem: function (data) {
      this.dialogModel.type = 'see';
      this.dialogModel.title = data.uriDesc;
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss"></style>
